var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export var SpacingUnit = function (_a) {
    var value = _a.value, getValue = _a.getValue, defaultValue = _a.defaultValue, placeholderValue = _a.placeholderValue;
    var units = ["", "px", "rem", "em"];
    var values = (defaultValue || "").split(" ");
    /*const v = (values[0] || "").trim();
    const u = (values[1] || "").trim();
    const splitDefault = { v: v, u: u };*/
    var parseValue = function (val) {
        var normalized = (val || "").trim();
        var number = normalized.replace(/[^\d]/g, "");
        var unit = normalized.replace(/[\d\s]/g, "") || "px";
        if (!normalized) {
            return {
                v: "",
                u: "",
            };
        }
        return {
            v: number,
            u: unit,
        };
    };
    var _b = useState(function () {
        var _a, _b;
        var parsed = parseValue(defaultValue);
        return {
            v: (_a = parsed.v) !== null && _a !== void 0 ? _a : "",
            u: (_b = parsed.u) !== null && _b !== void 0 ? _b : "",
        };
    }), editedValue = _b[0], setEditedValue = _b[1];
    useEffect(function () {
        var _a, _b;
        var parsed = parseValue(defaultValue);
        var nextValue = {
            v: (_a = parsed.v) !== null && _a !== void 0 ? _a : "",
            u: (_b = parsed.u) !== null && _b !== void 0 ? _b : "",
        };
        if (nextValue.v !== editedValue.v || nextValue.u !== editedValue.u) {
            setEditedValue(nextValue);
        }
    }, [defaultValue]);
    //const [editedValue, setEditedValue] = useState(splitDefault);
    useEffect(function () {
        //getValue(value, `${editedValue.v}${editedValue.u}`);
        if (editedValue.v === "") {
            getValue(value, "");
            return;
        }
        getValue(value, "".concat(editedValue.v).concat(editedValue.u || "px"));
        /*getValue(
          value,
          `${editedValue.v === "" ? "" : editedValue.v}${editedValue.u}`
        );*/
    }, [editedValue]);
    var parsedPlaceholder = parseValue(placeholderValue);
    var inputPlaceholder = parsedPlaceholder.v === "" ? "0" : parsedPlaceholder.v;
    var displayUnit = editedValue.u || parsedPlaceholder.u || "px";
    return (_jsx(_Fragment, { children: _jsxs("div", { children: [_jsx("label", {}), _jsxs("div", __assign({ className: "flex flex-row bg-white border-gray-400 rounded-md" }, { children: [_jsx("input", { 
                            //defaultValue={splitDefault.v}
                            value: editedValue.v, placeholder: inputPlaceholder, type: "text", className: "w-8", onChange: function (e) {
                                //setEditedValue({ ...editedValue, v: e.target.value });
                                var val = e.target.value;
                                if (/^\d*$/.test(val)) {
                                    setEditedValue(function (prev) { return (__assign(__assign({}, prev), { v: val, u: val === "" ? "" : prev.u })); });
                                }
                            } }), _jsx("select", __assign({ className: "bg-transparent", value: displayUnit, onChange: function (e) {
                                setEditedValue(__assign(__assign({}, editedValue), { u: e.target.value }));
                            } }, { children: units.map(function (item) { return (_jsx("option", __assign({ value: item, selected: item === editedValue.u ? true : false }, { children: item }), item)); }) }))] }))] }) }));
};
